import { FormatMoney } from '../../../../hooks/useMoney';

export function formatWithSign(value: number, formatMoney: FormatMoney) {
  const truncatedValue = Math.trunc(value);

  if (value > 0) {
    return `+${formatMoney(truncatedValue, { maximumFractionDigits: 0 })}`;
  }
  return `${formatMoney(truncatedValue, { maximumFractionDigits: 0 })}`;
}
